import {CommonStatus} from "@/enums/status";

export class FreightServiceAddParams {
    page? = 1;
    limit? = 50;
    search?: string;
    status?: CommonStatus;
    postOfficeRowGuid?: string;
}